import React, { useState, useEffect } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"; // Optional: For smooth entrance
import "./../../assets/css/TourPackagesSlider.css";
import BASE_URL from "../../component/commanfile";

export default function ModernTourPackagesSlider({ packages = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(4);
  const navigate = useNavigate();

  const totalPages = Math.ceil(packages?.length / visibleItems);

  useEffect(() => {
    const updateVisibleItems = () => {
      if (window.innerWidth < 768) setVisibleItems(1);
      else if (window.innerWidth < 992) setVisibleItems(2);
      else if (window.innerWidth < 1200) setVisibleItems(3);
      else setVisibleItems(4);
    };
    updateVisibleItems();
    window.addEventListener("resize", updateVisibleItems);
    return () => window.removeEventListener("resize", updateVisibleItems);
  }, []);

  const generateCarouselItems = () => {
    const carouselItems = [];
    for (let i = 0; i < totalPages; i++) {
      const startIndex = i * visibleItems;
      const packageSlice = packages.slice(startIndex, startIndex + visibleItems);

      carouselItems.push(
        <Carousel.Item key={i}>
          <Row className="px-2">
            {packageSlice.map((pkg) => (
              <Col key={pkg.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <motion.div 
                  className="modern-tour-card"
                  // whileHover={{ y: -10 }}
                >
                  {/* Image Section */}
                  <div className="card-img-wrapper">
                    <div className="type-badge">
                      {pkg.type === "fit" ? "Private" : "Group"}
                    </div>
                    <div className="duration-floating-badge">
                      {pkg.type === "fit" ? pkg.itinerary.length : pkg.duration} Days
                    </div>
                    <img
                      src={`${BASE_URL}${ (pkg.thumbnail?.substring(1))}`}
                      alt={pkg.name}
                      className="card-main-img"
                     
                    />
                  </div>

                  {/* Content Section */}
                  <div className="card-body-content">
                    <div                  
                     style={{
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: 600,
}}>{pkg.name}</div>
                    
                    <button
                      className="btn-explore"
                      onClick={() => navigate(`/tour-details/${pkg.type === "fit" ? `fit-${pkg.id}` : pkg.id}`, {
                        state: { tourId: pkg.id }
                      })}
                    >
                      View Details <span>&rarr;</span>
                    </button>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      );
    }
    return carouselItems;
  };

  if (!packages.length) return null;

  return (
    <div className="tour-slider-section">
      <Container>
        {/* <div className="slider-header-wrapper">
          <span className="subtitle">Exploration</span>
          <h2>Our Most Popular Tours</h2>
        </div> */}

        <div className="tour-packages-slider">
          <Carousel
            activeIndex={activeIndex}
            onSelect={(index) => setActiveIndex(index)}
            indicators={true}
            controls={true}
            interval={null}
            className="modern-tour-carousel"
          >
            {generateCarouselItems()}
          </Carousel>
        </div>
      </Container>
    </div>
  );
}